var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08975 14.0832C2.67415 14.0832 2.31919 13.936 2.02485 13.6416C1.73051 13.3473 1.58333 12.9923 1.58333 12.5767V1.99984H0.75V0.749862H4.49998V0.0126953H9.49998V0.749862H13.25V1.99984H12.4166V12.5767C12.4166 12.9977 12.2708 13.354 11.9791 13.6457C11.6875 13.9373 11.3312 14.0832 10.9102 14.0832H3.08975ZM11.1666 1.99984H2.83331V12.5767C2.83331 12.6515 2.85735 12.713 2.90544 12.761C2.95352 12.8091 3.01496 12.8332 3.08975 12.8332H10.9102C10.9743 12.8332 11.0331 12.8065 11.0865 12.753C11.1399 12.6996 11.1666 12.6408 11.1666 12.5767V1.99984ZM4.83654 11.1665H6.08652V3.66651H4.83654V11.1665ZM7.91344 11.1665H9.16341V3.66651H7.91344V11.1665Z",
    fill: "#617380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.a1c672d1.svg";
export { ForwardRef as ReactComponent };